export default __webpack_public_path__ + "static/media/game-score-fail-2.a3c9d90d.mp3";